import React, { useEffect, useState } from "react";
import Compound1 from "../assets/images/compound-1.svg";
import Elipse from "../assets/images/innovation-ellipse-22.svg";

const InnovationSection: React.FC = () => {
  const [carouselIndex, setCarouselIndex] = useState(0);

  const carouselItems = [
    <>...when skills connect to the networks that give them meaning</>,
    <>...when founders move from isolation to credibility</>,
    <>...when creators turn talent into enterprises that endure</>,
    <>...when public institutions see innovation as infrastructure</>,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  return (
    <>
      <div aria-hidden className="innovation-section">
        <div className="right-panel">
          <h2>
            CcHUB exists to make it easier for Africans to
            <span className="red-highlight">
              {" "}
              connect, build, learn, earn and prosper.
            </span>
          </h2>
          <div className="carousel-card">
            <div className="left-half-carousel-card">
              <p>In 2025, CcHUB measured what happens...</p>
              <div className="indicators">
                {carouselItems.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${carouselIndex === index ? "active" : ""}`}
                    onClick={() => setCarouselIndex(index)}
                  ></span>
                ))}
              </div>
            </div>
            <div className="right-half-carousel-card">
              {/* key forces React to re-mount the element, triggering the CSS slide animation */}
              <div className="carousel-item" key={carouselIndex}>
                <p>{carouselItems[carouselIndex]}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="left-panel">
          <img src={Compound1} alt="Animated Ecosystem World" />
        </div>
      </div>
      <img
        src={Elipse}
        alt="Transition Pattern"
        id="innovation-section-ellipse"
      />
      <div className="innovation-transition" />
    </>
  );
};

export default InnovationSection;
